import routes from "./router/routes"

export function appointmentModule({ router }) {
  for (const route of routes) router.addRoute("dashboard", route)
}
